document.addEventListener('DOMContentLoaded', () => {
  // Target all H1, H2, and any H4 you explicitly mark up
  const headings = document.querySelectorAll('h1, h2, .animate-heading-h4');
  if (!headings.length) return;

  // Add the base animation class to all targets
  headings.forEach((heading) => {
    heading.classList.add('heading-animate-target');
  });

  // Use IntersectionObserver when available
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animate in when entering viewport
            entry.target.classList.add('is-visible');
          } else {
            // Reset when leaving so it can re-animate next time
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        root: null,
        threshold: 0.25, // 25% visible before we trigger
      }
    );

    headings.forEach((heading) => observer.observe(heading));
  } else {
    // Fallback: scroll listener for older browsers
    const onScroll = () => {
      const viewportHeight = window.innerHeight;
      headings.forEach((heading) => {
        const rect = heading.getBoundingClientRect();
        const isVisible = rect.top < viewportHeight * 0.75 && rect.bottom > 0;

        if (isVisible) {
          heading.classList.add('is-visible');
        } else {
          heading.classList.remove('is-visible');
        }
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});
